export const classificationTabs = (cardSelector: string, panelSelector: string, label: string) => {
    if (window.location.pathname.toLowerCase().includes('-in-categories')) return;

    const tabs = Array.from(document.querySelectorAll<HTMLAnchorElement>('.classification-tabs > a'));
    const items = document.querySelectorAll<HTMLElement>(cardSelector);
    const panels = document.querySelectorAll<HTMLElement>(panelSelector);
    if (!tabs.length || !items.length || !panels.length) return;

    const tabList = tabs[0].parentElement;
    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', label);
    panels.forEach((panel, index) => {
        panel.id ||= `classification-panel-${index}`;
        panel.setAttribute('role', 'tabpanel');
    });

    const selectTab = (tab: HTMLAnchorElement) => {
        tabs.forEach(item => {
            item.classList.toggle('active', item === tab);
            item.setAttribute('aria-selected', String(item === tab));
            item.tabIndex = item === tab ? 0 : -1;
        });
        panels.forEach(panel => {
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = panel.querySelector(`${cardSelector}:not(.filter-out)`) ? -1 : 0;
        });
    };

    tabs.forEach((tab, index) => {
        tab.id ||= `classification-tab-${index}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', Array.from(panels, panel => panel.id).join(' '));
        tab.addEventListener('keydown', event => {
            if (event.key === ' ') {
                event.preventDefault();
                tab.click();
            }
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                event.preventDefault();
                const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
                next.click();
                next.focus();
            }
        });
        tab.onclick = event => {
            event.preventDefault();
            const category = tab.getAttribute('data-cat');
            items.forEach(item => {
                item.classList.toggle('filter-out', !!category && !(item.getAttribute('data-cats') || '').includes(category));
            });
            selectTab(tab);
        };
    });
    selectTab(tabs.find(tab => tab.classList.contains('active')) || tabs[0]);
};
